import cx from 'classnames'

import type { SimpleTemplateField } from '../../types/templateModel'
import { useFieldFrame } from '../templateFieldFrame/useFieldFrame'
import { useFieldValidations } from '../templateFieldValidations/useFieldValidations'
import { TemplateFieldFramesCellContent } from './TemplateFieldFramesCellContent'
import { TemplateFieldValidationsCellContent } from './TemplateFieldValidationsCellContent'

type Props = {
  field: SimpleTemplateField
}

export const SimpleFieldTypeFramesCell = ({ field }: Props) => {
  const { shouldRenderAFrame } = useFieldFrame(field)
  const validations = useFieldValidations(field)

  const shouldRenderValidations = !!validations?.length
  const shouldRenderSingleFPlusExpression =
    !shouldRenderValidations && shouldRenderAFrame

  return (
    <div
      className={cx('flex h-full w-full', {
        'gap-x-2': !shouldRenderSingleFPlusExpression,
      })}
    >
      <TemplateFieldFramesCellContent
        field={field}
        isSingleCellContent={!shouldRenderValidations}
      />
      <TemplateFieldValidationsCellContent field={field} />
    </div>
  )
}
